import React from 'react';
import './DashboardPage.css';
import SideBar from '../../components/SideBar/SideBar';
import Navbar from '../../components/NavBar/Navbar';
import { Outlet } from 'react-router-dom'; // Import Outlet
import { useAppContext } from '../../AppContext'; // Import useAppContext


const DashboardPage: React.FC = () => {
  const { user } = useAppContext(); // Get user from context
  
  return (
    <div className="dashboard-container">
      <Navbar username={user?.first_name || 'Usuario'} />
      <div className="content-area">
        <SideBar />
        <div className="main-content">
          <Outlet /> {/* This is where the child route's component will render */}
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;